import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class LocationDescription extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locId: this.props.locId,
      troupe: this.props.troupe,
      shouldDisplay: this.props.shouldDisplay,
      data: props.data
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      troupe: nextProps.troupe,
      locId: nextProps.locId,
      shouldDisplay: nextProps.shouldDisplay
    })
  }
  render() {

    var description, image, googleMapsUrl, arrow1, arrow2, arrow3

    if (this.state && this.state.data && this.state.troupe === 'A') {
      let d = this.state.data
      switch (this.state.locId) {
        case 1:
          description = d['france-description']
          image = 'url(' + assets('images/Loc-Chateau-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/LSmzLf'
          arrow1 = 'grid-loc-1'
          arrow2 = ''
          arrow3 = ''
          break
        case 2:
          description = d['france-description']
          image = 'url(' + assets('images/Loc-Chateau-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/LSmzLf'
          arrow1 = ''
          arrow2 = 'grid-loc-2'
          arrow3 = ''
          break
        case 3:
          description = d['japan-description']
          image = 'url(' + assets('images/Loc-Chiba-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/r1bw7D'
          arrow1 = ''
          arrow2 = ''
          arrow3 = 'grid-loc-3'
          break
      }
    }
    if (this.state && this.state.data && this.state.troupe === 'B') {
      let d = this.state.data
      switch (this.state.locId) {
        case 1:
          description = d['france-description']
          image = 'url(' + assets('images/Loc-Chateau-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/LSmzLf'
          arrow1 = 'grid-loc-1'
          arrow2 = ''
          arrow3 = ''
          break
        case 2:
          description = d['romania-description']
          image = 'url(' + assets('images/Loc-Romania-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/D4V5XO'
          arrow1 = ''
          arrow2 = 'grid-loc-2'
          arrow3 = ''
          break
        case 3:
          description = d['bali-description']
          image = 'url(' + assets('images/Loc-Bali-1.jpg') + ')',
          googleMapsUrl = 'https://goo.gl/KY9MO5'
          arrow1 = ''
          arrow2 = ''
          arrow3 = 'grid-loc-3'
          break
      }
    }

    let imageStyle = {
      backgroundImage: image,
      backgroundSize: 'cover',
      minHeight: '15vmin',
      height: '100%'
    }

    if (this.state.troupe === 'B' && !this.props.shouldDisplay) {
      return <div></div>
    }

    return (
      <div className="loc-description" >

        <div className="main-grid">
          <ul className="grid group">
            <li className='grid-small'><div className={arrow1}></div></li>
            <li className='grid-small grid-middle'><div className={arrow2}></div></li>
            <li className='grid-small'><div className={arrow3}></div></li>
          </ul>
        </div>

        <div className="main-grid">
          <ul className="grid group loc-description-content">
            <li className="grid-small">
              <p className="loc-description-p">{description}</p>
              <br></br>
              <b><a className="loc-map" href={googleMapsUrl} target="_blank">View on Google Maps</a></b>
            </li>
            <li className="grid-large inner-left">
              <div className="loc-description-image" style={imageStyle}></div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
LocationDescription.contextTypes = {
}
LocationDescription.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
    //data: state.token.data
  }
}

export default connect(mapStateToProps)(LocationDescription)



// WEBPACK FOOTER //
// ./src/components/Utils/LocationDescription.js